module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av44-285dc6accdad532d6ec8b48f3bfd52f9.jpg";